// removed by extract-text-webpack-plugin
module.exports = {"relative-grid":"relative-grid--3ky0L","switch-unit":"switch-unit--35Jpp"};


//////////////////
// WEBPACK FOOTER
// ./client/components/caluculator/calculator.scss
// module id = 500
// module chunks = 0